import React, {useContext} from 'react';
import {MissionListContext} from "../MissionListContext";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";
import {Card, CardContent, Grid, Paper, Table, TableBody, TableContainer} from "@mui/material";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../components/CustomButton";
import {WMSRoutes} from "../../../../utils/WMSRoutes";
import Header from "./Header";
import MissionItem from "./MissionItem";
import WmsMobileLayout from "../../wmsMobileLayout";

function MissionListMobile() {
    const {loading, missionList, history} = useContext(MissionListContext)

    const vhToPx = (vh) => {
        return (window.innerHeight * vh) / 100
    }

    return (
        <WmsMobileLayout>
            <WmsMobileLayout.Content>
                <Grid
                    container
                    direction={'column'}
                >
                    <Grid item>
                        <PageTitle
                            title={<FormattedMessage id={"wms.missionList.title"}/>}
                            subtitle={<FormattedMessage id={"wms.missionList.subtitle"}/>}
                        />
                    </Grid>

                    <Grid item sx={{marginLeft: 'auto', padding: "12px 16px"}}>
                        <CustomButton thicker onClick={() => history.push(`${WMSRoutes.NEW_MISSION}`)}>
                            <FormattedMessage id={"wms.missionList.redirectButton.newMission"}/>
                        </CustomButton>
                    </Grid>
                </Grid>

                {loading && 0 === missionList.length && (
                    <Grid item sx={{margin: "auto"}}>
                        <BeatLoaderRegular loading={loading}/>
                    </Grid>
                )}

                {0 < missionList.length && (
                    <Card sx={{height: '100%'}}>
                        <CardContent>
                            <Paper sx={{width: '100%', overflow: 'hidden'}}>
                                <TableContainer sx={{maxHeight: vhToPx(55)}}>
                                    <Table stickyHeader>
                                        <Header/>
                                        <TableBody>
                                            {missionList.length > 0 && missionList.map((mission) => {
                                                return (
                                                    <MissionItem
                                                        key={mission.id}
                                                        mission={mission}
                                                    />
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </CardContent>
                    </Card>
                )}
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    )
        ;
}

export default MissionListMobile;